import { useCallback, useEffect, useState } from 'react';
import { useClient } from '@/hooks/useClient';
import { recoverTransferIdentity } from '@/lib/transferIdentity';
import { accessClubClient } from '@/lib/clubData';
export interface ClubCoupon {kind:'bienvenida'|'segunda-visita';code:string;percentage:number;expiresAt:string|null;status:'disponible'|'usado'|'vencido'}
interface Wallet {coupons:ClubCoupon[];secondVisitReady:boolean;expiresAt:string}
export function useClubWallet(){
 const {client,updateClient}=useClient();const [wallet,setWallet]=useState<Wallet|null>(null),[error,setError]=useState(''),[loading,setLoading]=useState(true);
 const refresh=useCallback(async()=>{
  try{
   const identity=await recoverTransferIdentity(client,accessClubClient);
   if(identity.id!==client?.id)updateClient(identity);
   const res=await fetch('/api/public/club/coupons',{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({clientId:identity.id,name:identity.name,phone:identity.phone})});
   const data=await res.json();if(!res.ok)throw new Error(data.error||'No pudimos actualizar tus beneficios.');
   setWallet(data);setError('');
  }catch(e){setError(e instanceof Error?e.message:'No pudimos actualizar tus beneficios.');}finally{setLoading(false);}
 },[client,updateClient]);
 useEffect(()=>{void refresh();const onFocus=()=>void refresh();window.addEventListener('focus',onFocus);const timer=setInterval(onFocus,60000);return()=>{clearInterval(timer);window.removeEventListener('focus',onFocus);};},[refresh]);
 return {wallet,error,loading,refresh};
}
